import { AnalyticsEvent } from "../models";

export class SummerExtrasLeaderboardPageLoadEvent implements AnalyticsEvent {
  name = "SummerExtrasLeaderboardPageLoadEvent";
}